import { Location } from "fhir/r5";
import { loadAllResources, loadResource } from "./FhirBundleService";

// Search parameters
const LOCATION_SEARCH_PARAMS = {
  _count: "200",
  _elements: "id,name,identifier,status,mode,type,managingOrganization,partOf",
  _sort: "name",
};

const INTERNAL_LOCATION_SEARCH_PARAMS = {
  ...LOCATION_SEARCH_PARAMS,
  _tag: "internal",
};

// Resource loaders
async function loadLocation(locationId: string): Promise<Location> {
  return loadResource<Location>("Location", locationId ?? "");
}

async function loadAllLocations(): Promise<Location[]> {
  return loadAllResources<Location>("Location", LOCATION_SEARCH_PARAMS);
}

async function loadAllInternalLocations(): Promise<Location[]> {
  return loadAllResources<Location>("Location", INTERNAL_LOCATION_SEARCH_PARAMS);
}

// Exports
const LocationService = {
  loadLocation,
  loadAllLocations,
  loadAllInternalLocations,
};

export default LocationService;
